import { Box, Typography } from "@mui/material";

export default function BrandDetails() {
    return (
        <>
            <Box
                sx={{
                    width: 100,
                    height: 100,
                    margin: "0 auto",
                    borderRadius: 3,
                    backgroundImage: "url(/media/logo.png)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    mb: 1,
                }}
            />

            <Typography variant="h4" fontWeight={700}>
                Elmas Coffee
            </Typography>

            <Typography variant="body1" sx={{ opacity: 0.75, mb: 3 }}>
                Premium Coffee • A Story Worth Telling
            </Typography>
        </>
    );
}
